// @flow

import LogoAmex from '_images/card-logos/logo-dark-amex.png';
import LogoDefault from '_images/card-logos/logo-dark-default.png';
import LogoMC from '_images/card-logos/logo-dark-mc.png';
import LogoVisa from '_images/card-logos/logo-dark-visa.png';

type LogoType = 'default' | 'visa' | 'amex' | 'mc';

const getCardLogo = (brand: LogoType = 'default'): React$Node => {
  switch (brand) {
    case 'visa':
      return LogoVisa;
    case 'amex':
      return LogoAmex;
    case 'mc':
      return LogoMC;
    default:
      return LogoDefault;
  }
};

export default getCardLogo;
